<template>
    <div class="page">
        <ion-grid>
            <ion-row  class="rectangle">
                <ion-col>
                    <h5>Enter GST number</h5>
                    <ion-input
                    class="form-input"
                    type="text"
                    @input="gstNumber = $event.target.value"
                    ></ion-input>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-button  @click="addGstNumber">ADD</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { IonButton, IonCol, IonGrid, IonInput, IonRow, modalController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent({
    name: "AddOTPModel",
    components : {
        IonGrid, IonRow, IonCol, IonInput, IonButton, modalController
    },
    data() {
       return {
        gstNumber: ""
       } 
    },
    methods: {
        addGstNumber() {
            if(this.gstNumber == ''){
                new ToastUtils().presentToast("Enter GST Number");
            } else {
                modalController.dismiss(this.gstNumber)
            }
        }
    }
})
</script>

<style scoped>
.form-input {
    border: 2px solid rgba(0, 0, 0, 0.176);
    --highlight-color-focused : none;
}
</style>
